import { InputNumber, Select , Button } from 'antd'
import { currencies } from '../constants'

const { Option } = Select

type CostInputProps = {
  onCostChange: (cost: number) => void
  onCurrencyChange: (currency: string) => void
  currency?: string
  cost?: number
}

export function SelectCost({ onCostChange, onCurrencyChange, currency, cost }: CostInputProps) {
  return (

        <Select value={currency} defaultValue = {'SR'} className = 'h-10 select-dashboard' disabled bordered={false}  onChange={onCurrencyChange} style={{ width: 60 , border : 'none' }}>
          {Object.keys(currencies).map((key) => {
            const { value: currencyValue, logo } = currencies[key]
            return (
              <Option key={currencyValue} value={currencyValue}>
                {logo}
              </Option>
            )
          })}
        </Select>

     
  )
}
